import { ReactComponent as ErrorHint } from '../../res/img/error-hint.svg'

const ErrorHintText = ({ text, cls }) => {
  return (
    <div className={`error-hint ${cls}`}>
      <ErrorHint className='error-hint-icon' />
      <span>{text}</span>
    </div>
  )
}

export default ErrorHintText
